<template>
	<AppCard no-header>
		<template #body>
			<div class="slashed-card-container">
				<div class="slashed-left" :style="'--color-left:'+colorLeft+';'"><slot name="left"></slot></div>
				<div class="slashed-right"><slot name="right"></slot></div>
			</div>
		</template>
	</AppCard>
</template>

<script>
import AppCard from "@/shared/components/AppCard.vue";

export default {
	name: "CardSlashed",
	components: {
		AppCard
	},
	props: {
		colorLeft: {type: String, required: false, default: "transparent"},
	}
}
</script>

<style lang="scss" scoped>
.slashed-card-container {
	display: flex;
	justify-content: space-between;
	align-items: stretch;
	border-radius: 13px;

	.slashed-left, .slashed-right {
		display: flex;
		justify-content: center;
		padding: 10px;
		position: relative;
	}

	.slashed-left {
		width: 50%;
		border-top-left-radius: 13px;
		border-bottom-left-radius: 13px;
		color: var(--color-bg);
		position: relative;
		padding-right: 25px;
		overflow: hidden;
	}

	.slashed-right {
		width: calc(50% - 15px);
		border-top-right-radius: 13px;
		border-bottom-right-radius: 13px;
	}

	@media (max-width: 550px) {
		flex-direction: column;

		.slashed-left, .slashed-right {
			width: 100%;
		}

		.slashed-left {
			border-top-right-radius: 13px;
			border-bottom-left-radius: 0;
			padding-right: 0;
			min-height: 110px;
			padding-bottom: 30px;
		}

		.slashed-right {
			padding-top: 22px;
			border-top-left-radius: 0;
			border-bottom-right-radius: 13px;
		}
	}

}
</style>